import { WorkoutTypeEnum } from '../../../models/enums/workout-type.enum'
import { FieldSetupEnum } from '../../../models/enums/field-setup.enum'
import { Setup } from '../../../models/interfaces/setup.interface'
import i18n from '../../../i18n'

export const getDefaultSetup = (type: WorkoutTypeEnum) => {
  switch (type) {
    case WorkoutTypeEnum.BODYBUILDING:
      return [
        { field: FieldSetupEnum.SETS_REPETITIONS, value: '' },
        { field: FieldSetupEnum.INTERVAL, value: '' },
        { field: FieldSetupEnum.WEIGHT, value: '' }
      ]
    case WorkoutTypeEnum.ERGOMETER:
      return [
        { field: FieldSetupEnum.SETS, value: '' },
        { field: FieldSetupEnum.STIMULUS_TIME_DISTANCE, value: '' },
        { field: FieldSetupEnum.WEIGHT, value: '' },
        { field: FieldSetupEnum.SPEED, value: '' }
      ]
    case WorkoutTypeEnum.STRETCHING:
      return [
        { field: FieldSetupEnum.SETS_REPETITIONS, value: '' },
        { field: FieldSetupEnum.REST, value: '' }
      ]
    default: return []
  }
}

export const getFullSetupDefault = (type: WorkoutTypeEnum | undefined) => {
  switch (type) {
    case WorkoutTypeEnum.BODYBUILDING:
      return [
        { field: FieldSetupEnum.SETS_REPETITIONS, value: '' },
        { field: FieldSetupEnum.INTERVAL, value: '' },
        { field: FieldSetupEnum.WEIGHT, value: '' },
        { field: FieldSetupEnum.CADENCE, value: '' },
        { field: FieldSetupEnum.NOTE, value: '' }
      ]
    case WorkoutTypeEnum.ERGOMETER:
      return [
        { field: FieldSetupEnum.SETS, value: '' },
        { field: FieldSetupEnum.STIMULUS_TIME_DISTANCE, value: '' },
        { field: FieldSetupEnum.WEIGHT, value: '' },
        { field: FieldSetupEnum.SPEED, value: '' },
        { field: FieldSetupEnum.REST, value: '' },
        { field: FieldSetupEnum.PACE, value: '' },
        { field: FieldSetupEnum.NOTE, value: '' }
      ]
    case WorkoutTypeEnum.STRETCHING:
      return [
        { field: FieldSetupEnum.SETS_REPETITIONS, value: '' },
        { field: FieldSetupEnum.REST, value: '' },
        { field: FieldSetupEnum.NOTE, value: '' }
      ]
    default: return []
  }
}

export const getSetupOptionsBy = (types: WorkoutTypeEnum[]): Setup[] => {
  return types
    .map(type => {
      switch (type) {
        case WorkoutTypeEnum.BODYBUILDING:
          return [
            { field: FieldSetupEnum.SETS_REPETITIONS, value: '' },
            { field: FieldSetupEnum.INTERVAL, value: '' },
            { field: FieldSetupEnum.WEIGHT, value: '' },
            { field: FieldSetupEnum.CADENCE, value: '' },
            { field: FieldSetupEnum.NOTE, value: '' }
          ]
        case WorkoutTypeEnum.ERGOMETER:
          return [
            { field: FieldSetupEnum.SETS, value: '' },
            { field: FieldSetupEnum.STIMULUS_TIME_DISTANCE, value: '' },
            { field: FieldSetupEnum.WEIGHT, value: '' },
            { field: FieldSetupEnum.SPEED, value: '' },
            { field: FieldSetupEnum.REST, value: '' },
            { field: FieldSetupEnum.PACE, value: '' },
            { field: FieldSetupEnum.NOTE, value: '' }
          ]
        case WorkoutTypeEnum.STRETCHING:
          return [
            { field: FieldSetupEnum.SETS_REPETITIONS, value: '' },
            { field: FieldSetupEnum.REST, value: '' },
            { field: FieldSetupEnum.NOTE, value: '' }
          ]
        default: return []
      }
    })
    .flatMap(item => item)
    .filter((value, index, array) => index === array.findIndex(item => item.field === value.field))
}

export const getNameByField = (field: FieldSetupEnum) => {
  switch (field) {
    case FieldSetupEnum.SETS_REPETITIONS : return i18n.t('workout.setupField.setsRepetitions')
    case FieldSetupEnum.CADENCE : return i18n.t('workout.setupField.cadence')
    case FieldSetupEnum.INTERVAL : return i18n.t('workout.setupField.interval')
    case FieldSetupEnum.WEIGHT : return i18n.t('workout.setupField.weight')
    case FieldSetupEnum.NOTE : return i18n.t('workout.setupField.note')
    case FieldSetupEnum.SETS : return i18n.t('workout.setupField.sets')
    case FieldSetupEnum.STIMULUS_TIME_DISTANCE : return i18n.t('workout.setupField.stimulusTimeDistance')
    case FieldSetupEnum.SPEED : return i18n.t('workout.setupField.speed')
    case FieldSetupEnum.PACE : return i18n.t('workout.setupField.pace')
    case FieldSetupEnum.REST : return i18n.t('workout.setupField.rest')
    default: return ''
  }
}

export const getIconByField = (field: FieldSetupEnum) => {
  switch (field) {
    case FieldSetupEnum.SETS_REPETITIONS : return 'update'
    case FieldSetupEnum.CADENCE : return 'arrow-up-down'
    case FieldSetupEnum.INTERVAL : return 'clock-start'
    case FieldSetupEnum.WEIGHT : return 'weight-kilogram'
    case FieldSetupEnum.NOTE : return 'text'
    case FieldSetupEnum.SETS : return 'weight-lifter'
    case FieldSetupEnum.STIMULUS_TIME_DISTANCE : return 'run-fast'
    case FieldSetupEnum.SPEED : return 'speedometer'
    case FieldSetupEnum.PACE : return 'walk'
    case FieldSetupEnum.REST : return 'seat-recline-extra'
    default: return ''
  }
}

export const getYoutubeThumbById = (code: string) => {
  return `https://img.youtube.com/vi/${code}/mqdefault.jpg`
}
